module.exports = __webpack_public_path__ + "img/pepsi.cc70a9cd.png";